export default "__VITE_ASSET__BcPvFYqe__"